import { createSlice } from '@reduxjs/toolkit'

import type { RootState } from '../store'
import { getCustomService } from '../../helpers'
import {
  ArticlesParams,
  ArticlesResponse,
} from '../../rest/requests/articles/articles'

//
// requests
//

export const loadService = getCustomService<
  'load',
  ArticlesResponse,
  ArticlesParams
>('load')

//
// Initial state
//

export type ArticlesState = {
  // requests
  load: typeof loadService.state
}

const initialState: ArticlesState = {
  // requests
  load: loadService.state,
}

//
// Slice (Actions & Reducers)
//

const slice = createSlice({
  name: 'articles',
  initialState,
  reducers: {
    ...loadService.reducers,
  },
})

export const { reducer, actions } = slice

//
// Selectors
//

const root = (state: RootState) => state[slice.name]
const load = (state: RootState) => root(state).load

export const selectors = {
  load,
}
